import * as taskApi from "../../common/api/task_proc"

/**
 * 查任务进度
 * @param loginState
 * @param sandbox
 * @param offerId
 * @param groupid
 * @param task_id
 * @param task_token
 * @returns {Promise<T>}
 */
export function getTaskProgress({ loginState, sandbox, offerId, groupid, task_id, task_token = "" }) {
  return taskApi
    .taskProc(
      {
        offerId: offerId,
        sandbox: sandbox
      },
      {
        ...loginState,
        action: "get_task_progress",
        task_id: task_id,
        drm_info: `group_id=${groupid}&version=3.0&task_token=${task_token}`
      }
    )
    .then(res => {
      if (res.task_progress_detail && res.task_progress_detail.task_info && res.task_progress_detail.task_info.task_token) {
        //用户注册过
        return res.task_progress_detail.task_info
      } else {
        return {}
      }
    })
}

/**
 * 注册任务
 * @param offerId
 * @param sandbox
 * @param loginState
 * @param partitionInfo
 * @param task_id
 * @param groupid
 * @returns {Promise | Promise<unknown>}
 */

export function registerTask({ offerId, sandbox, loginState, partitionInfo, task_id, groupid }) {
  return taskApi.taskProc(
    {
      offerId: offerId,
      sandbox: sandbox
    },
    {
      ...loginState,
      ...partitionInfo,
      action: "register_task",
      task_id: task_id,
      drm_info: `group_id=${groupid}&version=3.0`
    }
  )
}

/**
 * 批量注册接口
 * @param offerId
 * @param sandbox
 * @param loginState
 * @param partitionInfo
 * @param task_id_list
 * @param groupid
 * @returns {Promise | Promise<unknown>}
 */
export function batchRegisterTask({ offerId, sandbox, loginState, partitionInfo, task_id_list, groupid }) {
  return taskApi.taskProc(
    {
      offerId: offerId,
      sandbox: sandbox
    },
    {
      ...loginState,
      ...partitionInfo,
      action: "batch_register_task",
      task_id_list,
      drm_info: `group_id=${groupid}&version=3.0`
    }
  )
}
/**
 * 领取任务奖励
 * @param loginState
 * @param partitionInfo
 * @param offerId
 * @param sandbox
 * @param task_id
 * @param groupid
 * @param present_rank
 * @returns {Promise | Promise<unknown>}
 */
export function getTaskPresent({ loginState, partitionInfo, offerId, sandbox, task_id, groupid, present_rank }) {
  return taskApi.taskProc(
    {
      offerId: offerId,
      sandbox: sandbox
    },
    {
      ...partitionInfo,
      ...loginState,
      present_rank,
      action: "task_present",
      task_id,
      drm_info: `group_id=${groupid}&version=3.0`
    }
  )
}

/**
 * 批量领取所有任务奖励
 * @param loginState
 * @param partitionInfo
 * @param offerId
 * @param sandbox
 * @param task_id
 * @param groupid
 * @param present_rank
 * @returns {Promise<unknown>}
 */
export function getAllTaskPresent({ loginState, partitionInfo, offerId, sandbox, task_id, groupid }) {
  return taskApi.taskProc(
    {
      offerId: offerId,
      sandbox: sandbox
    },
    {
      ...partitionInfo,
      ...loginState,
      action: "task_present_all",
      task_id,
      drm_info: `group_id=${groupid}&version=3.0`
    }
  )
}

/**
 * 查询参与任务的前置条件是否符合，本次活动是查询用户是否在对应分区对战
 * @param loginState
 * @param partitionInfo
 * @param offerId
 * @param sandbox
 * @param task_id
 * @param groupid
 * @param present_rank
 * @returns {Promise<unknown>}
 */
export function checkTaskPreCondition({ loginState, partitionInfo, offerId, sandbox, task_id, groupid, task_token }) {
  return taskApi.taskProc(
    {
      offerId: offerId,
      sandbox: sandbox
    },
    {
      ...partitionInfo,
      ...loginState,
      action: "query_precondition_check",
      query_action: "join_task",
      task_id,
      drm_info: `group_id=${groupid}&version=3.0&task_token=${task_token}`
    }
  )
}

/**
 * 参与任务
 * @param loginState
 * @param partitionInfo
 * @param offerId
 * @param sandbox
 * @param task_id
 * @param groupid
 * @param present_rank
 * @returns {Promise<unknown>}
 */
export function participateTask({ loginState, partitionInfo, offerId, sandbox, task_id, groupid, task_token }) {
  return taskApi.taskProc(
    {
      offerId: offerId,
      sandbox: sandbox
    },
    {
      ...partitionInfo,
      ...loginState,
      action: "join_task",
      task_id,
      drm_info: `group_id=${groupid}&version=3.0&task_token=${task_token}`
    }
  )
}
